export async function sha256(input: string): Promise<string> {
	const encoder = new TextEncoder();
	const data = encoder.encode(input);
	const hashBuffer = await crypto.subtle.digest("SHA-256", data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

const STORAGE_KEY = "cfp_auth";

export interface StoredAuth {
	accountName: string;
	accountId: string;
}

export function getStoredAuth(): StoredAuth | null {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		return JSON.parse(raw) as StoredAuth;
	} catch {
		return null;
	}
}

export function setStoredAuth(auth: StoredAuth): void {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
}

export function clearStoredAuth(): void {
	localStorage.removeItem(STORAGE_KEY);
}
